import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* removeUpload3(action) {
  var payload = {
    action: "portal/removeUpload3",
    assetId: action.assetId,
  };

  yield put(serverRequest(payload));
}

export default removeUpload3;
